// InsightRenderer — dispatcher that picks the right tile component
// based on ``display.type`` returned by the backend registry.
//
// Architecture rule: this file MUST NOT decide what to render based on
// the data shape — only on the registry's declared ``display.type``.
// All product logic lives in /backend/services/insights_registry.py.
import React from 'react';
import InsightCard from './InsightCard';
import InsightTable from './InsightTable';
import InsightList from './InsightList';

export function InsightRenderer({ insight, loading, error, isAr }) {
  if (!insight) return null;
  const type = insight.display?.type;

  if (type === 'kpi') {
    return <InsightCard insight={insight} loading={loading} error={error} isAr={isAr} />;
  }
  if (type === 'list') {
    return <InsightList insight={insight} loading={loading} error={error} isAr={isAr} />;
  }
  // Default to table — covers the majority of recipes.
  return <InsightTable insight={insight} loading={loading} error={error} isAr={isAr} />;
}

export default InsightRenderer;
